<template>
  <div>
    <v-row class="ma-0">
      <v-col class="d-flex row-from">
        <!-- search from -  to  -->
        <strong class="mt-2 mr-2">日時</strong>
        <DatePicker
          v-model="from"
          :max="$moment(new Date()).format('YYYY-MM-DD HH:mm')"
          class="mr-5"
        />
        <TimePicker
          v-model="timeFrom"
          :disabled="!from"
          :key="timePickerKey"
          :max="minTimeFrom"
        />
      </v-col>
      <v-col class="d-flex row-from">
        <strong>から</strong>
        <DatePicker
          v-model="to"
          :min="from"
          :max="$moment(new Date()).format('YYYY-MM-DD HH:mm')"
          class="mr-5"
        />
        <TimePicker
          :min="minTimeTo"
          :max="maxTimeTo"
          class="mr-5"
          v-model="timeTo"
          :disabled="!to"
          :key="timePickerKey"
        />
        <span class="font-weight-bold mt-2" style="min-width: 40px">まで</span>
      </v-col>
      <v-col class="d-flex row-from">
        <strong>IP</strong>
        <v-text-field
          v-model.trim="ip"
          :placeholder="$t('keyword-title')"
          dense
          hide-details
          class="max-width-2 mr-5"
          outlined
          @keydown.enter="search"
        />
      </v-col>
      <v-col class="d-flex row-from">
        <strong>説明</strong>
        <v-text-field
          v-model.trim="description"
          hide-details
          :placeholder="$t('keyword-title')"
          dense
          class="mr-5 max-width-3"
          outlined
          @keydown.enter="search"
        />
      </v-col>
      <v-col class="d-flex row-from">
        <strong>アクション</strong>
        <v-text-field
          v-model.trim="action"
          hide-details
          :placeholder="$t('keyword-title')"
          dense
          class="max-width-3 mr-5"
          outlined
          @keydown.enter="search"
        />
      </v-col>
      <v-col>
        <v-btn color="primary" @click="search">検索</v-btn>
      </v-col>
    </v-row>
    <!-- List log -->
    <v-layout class="row mx-1 mt-5" child-flex>
      <v-data-table
        :headers="headers"
        fixed-header
        :items="listActivityLog"
        :loading="loaddingListActivityLog"
        :items-per-page.sync="pagination.maxResultCount"
        :page="pagination.page"
        loading-text="読み込み中。。。待ってください。"
        hide-default-footer
        class="elevation-1"
      >
        <!-- Custom display of sequence number -->
        <template v-slot:[`item.rn`]="{ item }">
          {{
            _.findIndex(listActivityLog, function (o) {
              return o.rn == item.rn;
            }) + 1
          }}
        </template>
        <!-- Customizable creation date -->
        <template v-slot:[`item.created_at`]="{ item }">{{
          item.created_at
            ? $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
            : null
        }}</template>
        <!-- Custom display of action -->
        <template v-slot:[`item.action`]="{ item: {action} }">{{
          actionLog[action]
        }}</template>
        <!-- Custom displays where there is no data  -->
        <template v-slot:no-data>
          <div class="text-center">データがありません。</div>
        </template>
      </v-data-table>
    </v-layout>
    <v-row class="mx-1 mt-2">
      <v-spacer />
      <BasePagination
        v-if="listActivityLog.length > 0"
        class="mt-5"
        :pageCount="pagination.pageCount"
        :pageSize="pagination.maxResultCount"
        @changePage="(value) => (pagination.page = value)"
      />
    </v-row>
    <v-row class="mx-1">
      <v-spacer />
      <v-btn class="mt-2 mr-2" @click="goBack">戻る</v-btn>
    </v-row>
  </div>
</template>

<script>
import mixin from "@/mixin";
import BasePagination from "@/components/Pagination/BasePagination";
import { getLogUserById } from "@/api/Log.api";
import DatePicker from "@/components/DatePicker/DatePicker";
import TimePicker from "@/components/TimePicker/TimePicker";
// eslint-disable-next-line vue/no-parsing-error
import actionLog from "@/statics/actionLog.json";
export default {
  store: ["usernameLog"],
  mixins: [mixin.App],
  components: { BasePagination, DatePicker, TimePicker },
  data() {
    return {
      date: "",
      listActivityLog: [],
      loaddingListActivityLog: false,
      dialogCreateUser: false,
      timePickerKey: 0,
      headers: [
        {
          text: "No.",
          align: "start",
          value: "rn",
        },
        { text: "日時", value: "created_at" },
        { text: "IP", value: "ip" },
        { text: "アクション", value: "action" },
        { text: "説明", value: "data" },
      ],
      actionLog,
      menu: false,
      description: "",
      from: "",
      to: "",
      ip: "",
      action: "",
      timeTo: "",
      timeFrom: "",
    };
  },
  async created() {
    await this.handleGetLogUserById();
  },
  computed: {
    minTimeTo() {
      const { from, to, timeFrom } = this;
      var val;
      if (from == "" || to == "") {
        val = null;
      } else if (from == to) {
        val = timeFrom;
      }
      return val;
    },
    maxTimeTo() {
      const { to, $moment } = this;
      if (to == $moment(new Date()).format("YYYY-MM-DD")) {
        return $moment(new Date()).format("HH:mm");
      }
      return "";
    },
    minTimeFrom() {
      const { from, $moment } = this;
      if (from == $moment(new Date()).format("YYYY-MM-DD")) {
        return $moment(new Date()).format("HH:mm");
      }
      return "";
    },
  },
  watch: {
    "pagination.page": async function () {
      await this.handleGetSystem();
    },
    from: function (val) {
      if (val == "") {
        this.timeFrom = "";
      }
      if (new Date(val).getTime() > new Date(this.to).getTime()) {
        this.to = "";
      }
    },
    to: function (val) {
      if (val == "") {
        this.timeTo = "";
      }
    },
    timeFrom: function () {
      this.timePickerKey++;
    },
    timeTo: function () {
      this.timePickerKey++;
    },
  },
  methods: {
    async search() {
      this.handleGetLogUserById();
    },
    async handleGetLogUserById() {
      this.loaddingListActivityLog = true;
      this.pagination.maxResultCount = 100;
      const { name, params, query } = this.$route;
      const { page } = this.pagination;
      const { description, from, to, ip, action, timeFrom, timeTo } = this;
      let req = {
        page,
        key: description,
        from: "",
        to: "",
        ip,
        action,
      };
      if (name == "Activity log user") {
        req.type = "USER";
      } else if (name == "Activity log teacher") {
        req.type = "TEACHER";
      }
      if (timeFrom !== "" && from !== "") {
        req.from = `${from} ${timeFrom}`;
      } else if (from !== "") {
        req.from = from;
      }
      if (timeTo !== "" && to !== "") {
        req.to = `${to} ${timeTo}`;
      } else if (to !== "") {
        req.to = to;
      }
      console.log("query: ", query);
      this.usernameLog = query.username;
      req.user_id = params.id;
      req.email = query.email
      await getLogUserById(req).then((res) => {
        const { result } = res;
        this.listActivityLog = result;
        this.pagination.pageCount = res.totalCount;
      });
      // }
      this.loaddingListActivityLog = false;
    },
    goBack() {
      console.log(this.$route);
      const { name, query } = this.$route;
      if (name == "Activity log teacher") {
        this.$router.push({ name: "List Teacher" });
      } else {
        this.$router.push({ name: "Detail user", params: { ...query } });
      }
    },
  },
};
</script>

<style scoped>
strong {
  min-width: 115px;
  max-width: 115px;
  margin: 8px 8px 0 0;
}
.row-from {
  min-width: 460px;
  max-width: 460px;
}
</style>